"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactI18nify = require("react-i18nify");

var _icon = _interopRequireDefault(require("@internet-features/icon"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var Legal = /*#__PURE__*/function (_React$Component) {
  _inherits(Legal, _React$Component);

  function Legal() {
    _classCallCheck(this, Legal);

    return _possibleConstructorReturn(this, _getPrototypeOf(Legal).apply(this, arguments));
  }

  _createClass(Legal, [{
    key: "render",
    // eslint-disable-next-line max-lines-per-function
    value: function render() {
      var store = this.context.store;

      var _store$getState = store.getState(),
          config = _store$getState.config;

      var currentYear = new Date().getFullYear();
      var linkRows = [[{
        "content": _react["default"].createElement(_reactI18nify.Translate, {
          value: "footer.legal.copyright",
          copyrightYear: currentYear
        })
      }, {
        "content": _react["default"].createElement(_reactI18nify.Translate, {
          value: "footer.ccpa.yourPrivacyRights"
        }),
        "href": config.get("footer.ccpa.yourPrivacyRights")
      }, {
        "content": _react["default"].createElement(_reactI18nify.Translate, {
          value: "footer.ccpa.consumerPrivacyRights"
        }),
        "href": config.get("footer.ccpa.consumerPrivacyRights")
      }], [{
        "content": _react["default"].createElement(_reactI18nify.Translate, {
          value: "footer.ccpa.consumerDoNotSell"
        }),
        "href": config.get("footer.ccpa.consumerDoNotSell")
      }, {
        "content": _react["default"].createElement(_reactI18nify.Translate, {
          value: "footer.ccpa.consumerLimitUse"
        }),
        "href": config.get("footer.ccpa.consumerLimitUse")
      }, {
        "content": _react["default"].createElement(_reactI18nify.Translate, {
          value: "footer.legal.policies"
        }),
        "href": config.get("footer.legal.policies")
      }, {
        "content": _react["default"].createElement(_reactI18nify.Translate, {
          value: "footer.legal.assist"
        }),
        "href": config.get("footer.legal.assist")
      }]];
      var linksList = linkRows.map(function (linkRow, rowIndex) {
        return _react["default"].createElement("div", {
          key: rowIndex
        }, linkRow.map(function (link, linkIndex) {
          var separator = "";
          var linkText = link.content;

          if (linkIndex !== 0) {
            separator = _react["default"].createElement("span", {
              className: "vertical-separator border-light mx-3 d-none d-md-inline"
            });
          }

          if (link.href) {
            linkText = _react["default"].createElement("a", {
              className: "text-light focus-outline-primary small",
              target: "_blank",
              rel: "noopener noreferrer",
              href: link.href
            }, link.content, _react["default"].createElement("span", {
              className: "sr-only"
            }, _react["default"].createElement(_reactI18nify.Translate, {
              value: "header.newWindow"
            })));
          }

          return _react["default"].createElement("span", {
            className: "d-block d-md-inline mb-2 mb-md-0",
            key: linkIndex
          }, separator, linkText);
        }));
      });
      return (// The role attribute is listed here because VoiceOver has an issue where the footer landmark role is not announced in the landmark rotor without it
        _react["default"].createElement("footer", {
          role: "contentinfo",
          className: "row bt-2-solid-light legal"
        }, _react["default"].createElement("div", {
          className: "col-12 col-lg-2 text-center text-lg-left mb-3"
        }, _react["default"].createElement("a", {
          className: "focus-outline-primary",
          "aria-label": "Charter Communications Logo",
          href: config.get("footer.url")
        }, _react["default"].createElement(_icon["default"], {
          name: "/assets/images/CharterLogoFooter.svg#Charter-Logo-Footer",
          "aria-label": "Charter Communications Logo",
          "aria-hidden": true,
          style: {
            "fill": "#fff",
            "height": "36px",
            "width": "114px"
          }
        }))), _react["default"].createElement("div", {
          className: "col-12 col-lg-10 text-center text-lg-left"
        }, linksList))
      );
    }
  }]);

  return Legal;
}(_react["default"].Component);

Legal.contextTypes = {
  "store": _propTypes["default"].object.isRequired
};
var _default = Legal;
exports["default"] = _default;